<template>
  <div class="promotes">
    <div class="row">
      <div class="col-md-12">
        <div class="widget">
          <div class="form-elements-sec">
            <div class="widget-title">
              <h3>Reklam Ekle</h3>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="dorm">Yurt</label>
                  <!-- <select class="form-control custom-input" v-model="dorm">
                    <option value selected disabled hidden>Seçiniz...</option>
                    <option v-for="dorm in dorms" :key="dorm.key" :value="dorm.id">{{ dorm.name }}</option>
                  </select> -->
                  <model-select :options="dorms"
                    v-model="dorm"
                    placeholder="Yurt Seçimi"
                    class="form-control custom-input">
                  </model-select>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="promote_type">Reklam Tipi</label>
                  <select
                    v-model="promote_type"
                    class="form-control custom-input"
                    @change="promoteChange"
                  >
                    <option value selected disabled hidden>Seçiniz...</option>
                    <option
                      v-for="promote_type in promote_types"
                      :key="promote_type.key"
                      :value="promote_type.id"
                    >{{ promote_type.name }}</option>
                  </select>
                </div>
              </div>
              <div class="row" v-if="this.promote_type == 9">
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="color">Renk Seçimi <small>(HEX Code)</small></label>
                    <input type="text" class="form-control custom-input" v-model="color" placeholder="örn: #EFEFEF">
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="top_title">Üst Başlık</label>
                    <input type="text" v-model="top_title" class="form-control custom-input">
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="bottom_title">Alt Başlık</label>
                    <input type="text" v-model="bottom_title" class="form-control custom-input">
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="city">İl</label>
                  <select
                    v-model="city"
                    class="form-control custom-input"
                    :readonly="this.rCity"
                    @change="getFilter"
                  >
                    <option value selected disabled hidden>Seçiniz...</option>
                    <option v-for="city in cities" :key="city.key" :value="city.id">{{ city.name }}</option>
                  </select>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="district">İlçe</label>
                  <select
                    v-model="district"
                    class="form-control custom-input"
                    :readonly="this.rDistrict"
                  >
                    <option value selected disabled hidden>Seçiniz...</option>
                    <option
                      v-for="district in districts"
                      :key="district.key"
                      :value="district.id"
                    >{{ district.name }}</option>
                  </select>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="university">Üniversite</label>
                  <select
                    v-model="university"
                    class="form-control custom-input"
                    :readonly="this.rUniversity"
                    @change="getFaculties"
                  >
                    <option value selected disabled hidden>Seçiniz...</option>
                    <option
                      v-for="university in universities"
                      :key="university.key"
                      :value="university.id"
                    >{{ university.name }}</option>
                  </select>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="faculty">Fakülte</label>
                  <select
                    v-model="faculty"
                    class="form-control custom-input"
                    :readonly="this.rFaculty"
                  >
                    <option value selected disabled hidden>Seçiniz...</option>
                    <option
                      v-for="faculty in faculties"
                      :key="faculty.key"
                      :value="faculty.id"
                    >{{ faculty.name }}</option>
                  </select>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="faculty">Yurt Tipi</label>
                  <select
                    v-model="dorm_type"
                    class="form-control custom-input"
                    :readonly="this.rDormType"
                  >
                    <option value selected disabled hidden>Seçiniz...</option>
                    <option value="1">Erkek Öğrenci Yurdu</option>
                    <option value="2">Kız Öğrenci Yurdu</option>
                  </select>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="sort">Sıralama</label>
                  <input
                    type="text"
                    v-model="sort"
                    class="form-control custom-input"
                    :readonly="this.rSort"
                  >
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="start_date">Başlangıç Tarihi</label>
                  <input type="date" v-model="start_date" class="form-control custom-input">
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="end_date">Bitiş Tarihi</label>
                  <input type="date" v-model="end_date" class="form-control custom-input">
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group">
                  <label for></label>
                  <button class="btn btn-success pull-right" @click="addData">Kaydet</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ModelSelect } from 'vue-search-select'
export default {
  components: {
      ModelSelect
    },
  data() {
    return {
      api: "promotes/",
      dorms: [],
      dorm: "",
      promote_types: [],
      promote_type: "",
      cities: [],
      city: "",
      districts: [],
      district: "",
      universities: [],
      university: "",
      faculties: [],
      dorm_type: "",
      color: "",
      top_title: "",
      bottom_title: "",
      faculty: "",
      sort: "",
      start_date: "",
      end_date: "",
      rCity: null,
      rDistrict: null,
      rUniversity: null,
      rSort: null,
      rFaculty: null,
      rDormType: null
    };
  },
  created() {
    this.getData();
  },
  computed: {
    options() {
      return this.dorms
    }
  },
  methods: {
    addData() {
      this.$Progress.start();
      var data = {
        dorm: this.dorm,
        promote_type: this.promote_type,
        city: this.city,
        district: this.district,
        university: this.university,
        faculty: this.faculty,
        dorm_type: this.dorm_type,
        sort: this.sort,
        top_title: this.top_title,
        bottom_title: this.bottom_title,
        color: this.color,
        start_date: this.start_date,
        end_date: this.end_date
      };
      const formData = new FormData();
      Object.keys(data).map(e => {
        formData.append(e, data[e]);
      });
      this.axios
        .post(this.api, data)
        .then(response => {
          if (response.status == 201) {
            this.$Progress.finish();
            this.$router.push({
              name: "promotes.update",
              params: { id: response.data.id }
            });
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch(error => {
          // console.log(error);
        });
    },
    getData() {
      this.axios
        .get(this.api + "create")
        .then(response => {
          this.dorms = response.data.dorms;
          this.promote_types = response.data.promote_types;
          this.cities = response.data.cities;
          this.universities = response.data.universities;
          // console.log(this.dorms);
        })
        // eslint-disable-next-line no-unused-vars
        .catch(error => {
          // console.log(error);
        });
    },
    getFaculties() {
      this.$Progress.start();
      this.axios.get("search/faculties/" + this.university).then(response => {
        this.faculties = response.data;
        this.$Progress.finish();
      });
    },
    reset() {
      this.city = "";
      this.district = "";
      this.university = "";
      this.sort = "";
      this.faculty = "";
      this.rCity = null;
      this.rDistrict = null;
      this.rUniversity = null;
      this.rSort = null;
      this.rFaculty = null;
      this.rDormType = null;
    },
    getFilter() {
      if (this.rDistrict === null) {
        this.$Progress.start();
        this.axios.get("districts/" + this.city).then(response => {
          this.districts = response.data;
          this.$Progress.finish();
        });
      }
    },
    promoteChange() {
      this.reset();

      if (this.promote_type == 1) {
        this.rCity = true;
        this.rDistrict = true;
        this.rUniversity = true;
        this.rFaculty = true;
        this.rDormType = true;
      }
      if (this.promote_type == 2) {
        this.rDistrict = true;
        this.rUniversity = true;
        this.rFaculty = true;
        this.rDormType = true;
      }
      if (this.promote_type == 3) {
        this.sort = 1;
        this.rSort = true;
      }
      if (this.promote_type == 7 || this.promote_type == 8) {
        this.rCity = true;
        this.rDistrict = true;
        this.rUniversity = true;
        this.rFaculty = true;
        this.rDormType = true;
      }
    }
  }
};
</script>

<style scoped>
  .text {
    top: 8px !important;
    color: #666 !important;
  }
</style>
